import {
  axiosDelete,
  axiosGet,
  axiosPatch,
  axiosPost,
  fetchImage,
} from '../axios/axios.config';

export const searchContacts = async (data) => {
  const response = await axiosGet('data/api/types/contact', data);
  return response;
};

export const createContacts = async (data) => {
  const response = await axiosPost('data/api/types/contact', data);
  return response;
};

export const updateContacts = async (contactId, data) => {
  const response = await axiosPatch(
    `data/api/types/contact/${contactId}`,
    data
  );
  if (response.status === 500) {
    return Promise.reject(response.data);
  }
  return response;
};

export const getContactImage = async (contactId) => {
  const response = await fetchImage(
    `data/api/types/contact/${contactId}/avatar`,
    { responseType: 'arraybuffer' }
  );
  return response;
};

export const updateContactImage = async (contactId, data) => {
  const response = await axiosPost(`data/api/types/contact/${contactId}`, data);
  return response;
};

export const deleteContact = async (contactId) => {
  const response = await axiosDelete(`data/api/types/contact/${contactId}`);
  return response;
};
